export default __webpack_public_path__ + "img/4d4faf1ff0c47b5892fbdcf5cc8ad143.svg";